import { createAction, props } from '@ngrx/store';
import {
  PaymentCompletedResponse,
  PaymentStatus,
} from '@arc/unified-payments-frontend/shared-payment';

export const PoiIntlStripeResultPaymentComponentActions = {
  updateTransactionAuthorizationResults: createAction(
    '[POI Intl Stripe Result] Update Transaction Authorization Results',
    props<{
      transactionAuthorizationResult: Array<{
        gpalStatus: PaymentStatus;
        paymentDate: string;
      }>;
      transactionReference: string;
    }>(),
  ),
  paymentCompleted: createAction(
    '[POI Intl Stripe Result] Payment Completed',
    props<{
      payload: PaymentCompletedResponse;
    }>(),
  ),
  stripeRedirectCompleted: createAction(
    '[POI Intl Stripe Result] Stripe Redirect Completed',
    props<{
      isSuccess: boolean;
    }>(),
  ),
  updateSessionStatusToActiveSuccess: createAction(
    '[POI Intl Stripe Result] Update Session Status To Active Success',
  ),
  updateSessionStatusToActiveFailed: createAction(
    '[POI Intl Stripe Result] Update Session Status To Active Failed',
  ),
};
